<div style="margin: 20px; min-width: 400px;">
  <h2>Szczegóły walidatora</h2>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <label>Id</label>
      <input pInputText value="{{validatorProvider.id}}" [disabled]="true"/>
    </div>
    <div class="ui-g-12">
      <label>Skrót</label>
      <input pInputText value="{{validatorProvider.abbreviation}}" [disabled]="true" />
    </div>
    <div class="ui-g-12">
      <label>Nazwa SkiData</label>
      <input pInputText value="{{validatorProvider.name}}" [disabled]="true" />
    </div>
    <div class="ui-g-12">
      <label>Nazwa</label>
      <input pInputText maxlength="64" [(ngModel)]="validatorProvider.label" />
    </div>
    <div class="ui-g-12">
      <p-checkbox binary="true" [(ngModel)]="validatorProvider.active" label="Czy aktywny"></p-checkbox>
    </div>
    <div class="ui-g-12">
      <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
      <p-button class="button" (click)="save()" label="Zapisz"></p-button>
    </div>
  </div>
</div>
